import { useAccountBalanceCommon } from '@eih-netbroker/common';

export const useAccountBalance = useAccountBalanceCommon;
